import React, { useEffect, useMemo, useState } from 'react';
import { Button } from '@/components/ui/button';
import clsx from 'clsx';
// import { X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getImageKitImageUrlForSanity } from '@/content/contentHelpers';
import matomo from '@/utils/matomo';

const AdCarousel = ({ items /* onAdCarouselSlideClose */ }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [maxHeight, setMaxHeight] = useState(0);
  const slideRefs = useMemo(
    () => (items || []).map(() => React.createRef()),
    [items]
  );

  useEffect(() => {
    const heights = slideRefs.map((ref) => ref.current?.offsetHeight || 0);
    if (heights.length > 0) {
      const newMaxHeight = Math.max(...heights);
      if (newMaxHeight > 0) {
        setMaxHeight(newMaxHeight);
      }
    }
  }, [slideRefs]);

  useEffect(() => {
    if (items.length > 0) {
      matomo.clickEvent({
        category: 'Global dashboard banner carousel',
        name: 'Banner slide shown',
        action: `Showed: ${items[activeSlide].title}`,
      });
    }
  }, [items]);

  if (!items || items.length === 0) return null;
  return (
    <div className="flex flex-col gap-4 my-4">
      <div
        className="relative min-h-[120px]"
        style={{ height: `${maxHeight}px` }}
      >
        {items.map((el, index) => (
          <div
            ref={slideRefs[index]}
            className={clsx([
              'absolute flex left-0 top-0 flex-col justify-between md:justify-start w-full md:flex-row gap-2 px-[21px] py-[18px] min-h-[100%] bg-white border rounded-[5px]',
              index === activeSlide
                ? 'opacity-100'
                : 'opacity-0 pointer-events-none',
            ])}
            key={el.title}
          >
            <img
              className="object-contain self-center md:self-start w-[84px] md:w-[70px] h-[84px] md:h-[70px]"
              alt="carousel"
              src={
                el.image ||
                getImageKitImageUrlForSanity(el.slideImage?.asset, 200)
              }
            />
            <div className="flex flex-col justify-between items-start">
              <div className="flex flex-col items-start">
                <h2 className="text-xl font-bold">{el.title}</h2>
                <p className="max-w-[480px]">{el.paragraph}</p>
              </div>
              <Button
                onClick={() => {
                  matomo.clickEvent({
                    category: 'Global dashboard banner carousel',
                    name: 'Banner slide button clicked',
                    action: `Clicked button to: ${el.pathName}`,
                  });
                }}
                variant="outline"
                className="mt-[15px] border-red-500"
              >
                <Link to={el.pathName}>{el.buttonText || 'Sjekk ut'}</Link>
              </Button>
            </div>
            {/* <button
              aria-label="close carousel"
              className="absolute right-3 top-3"
              type="button"
              onClick={() =>
                onAdCarouselSlideClose &&
                (onAdCarouselSlideClose(index), setActiveSlide(0))
              }
            >
              <X color="#999" width={16} height={16} />
            </button> */}
          </div>
        ))}
      </div>
      <div className="flex gap-2">
        {items.map((el, index) => (
          <Button
            key={el.title}
            onClick={() => activeSlide !== index && setActiveSlide(index)}
            className={clsx([
              'w-[40px] h-[40px] border text-xl hover:text-gray-400',
              activeSlide === index && 'bg-accent text-gray-400',
            ])}
            variant="outline"
          >
            {index + 1}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default AdCarousel;
